import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

import { Cabecalho, Caixa, Corpo, Fundo, Rodape } from './styles';
import Button from '../Button';

interface ModalProps {
  titulo: string;
  onClose: () => void;
  children: React.ReactNode;
  rodape?: React.ReactNode;
}

// Modal padrão: centralizado no desktop, tela cheia no mobile. Fecha com Esc ou clique no fundo.
export default function Modal({ titulo, onClose, children, rodape }: ModalProps) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }

    const overflowAnterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = overflowAnterior;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <Fundo onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <Caixa role='dialog' aria-modal='true' aria-label={titulo}>
        <Cabecalho>
          <h3>{titulo}</h3>
          <Button variante='fantasma' icone={<FaTimes />} onClick={onClose} aria-label='Fechar' />
        </Cabecalho>
        <Corpo>{children}</Corpo>
        {rodape && <Rodape>{rodape}</Rodape>}
      </Caixa>
    </Fundo>
  );
}
